/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/components/tutorial-step/app.tutorial-step.component.ts.
 */
import {Component, Input, ViewChild} from '@angular/core';
import {AppTutorialsComponent} from '../tutorials/app.tutorials.component';
import {AppWalkthroughComponent} from '../walkthrough/app.walkthrough.component';

/**
 * Zweck: Beschreibt class AppTutorialStepComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'app-tutorial-step',
    templateUrl: 'app.tutorial-step.component.html',
    standalone: false
})
export class AppTutorialStepComponent {
  static id = 'AppTutorialStepComponent';
  @Input() tutorial: AppTutorialsComponent;
  @Input() text: string;
  @Input() focus_on: string;
  @Input() icon: string;

  @ViewChild('walkthrough') walkthrough: AppWalkthroughComponent;

  visible = true;

/**
 * Beschreibt Methode setSeen und ihren Rückgabevertrag.
 */
  setSeen() {
    this.tutorial.setSeen();
  }
}
